type BalanceValue = number | null | undefined;
type BalanceFormatter = (balance: number) => string;
export type DashboardBalanceTrend =
  | "increased"
  | "decreased"
  | "unchanged"
  | null;

export const isDashboardBalanceAvailable = (
  balance: BalanceValue
): balance is number => balance !== null && balance !== undefined;

export const getDashboardBalanceDisplay = (
  balance: BalanceValue,
  formatBalance: BalanceFormatter
) => {
  const isAvailable = isDashboardBalanceAvailable(balance);

  return {
    isAvailable,
    value: isAvailable ? formatBalance(balance) : "--",
    text: isAvailable ? "Compared to last month" : "N/A",
  };
};

export const getDashboardBalanceTrend = (
  currentBalance: BalanceValue,
  lastMonthBalance: BalanceValue
): DashboardBalanceTrend => {
  if (
    !isDashboardBalanceAvailable(currentBalance) ||
    !isDashboardBalanceAvailable(lastMonthBalance)
  ) {
    return null;
  }

  if (currentBalance === lastMonthBalance) {
    return "unchanged";
  }

  return currentBalance < lastMonthBalance ? "decreased" : "increased";
};
